import { ENGLISH_IQ_STORED_SESSION_VERSION, SUPPORTED_LOCALES } from '@repo/config';
import { z } from 'zod';
import { englishIqItemSchema } from './english-iq-item-schema';
import { englishIqMilestoneSchema } from './english-iq-milestone-schema';

export const englishIqStoredSessionSchema = z.object({
  expiresAt: z.number().int().positive(),
  index: z.number().int().positive(),
  item: englishIqItemSchema,
  locale: z.enum(SUPPORTED_LOCALES),
  milestone: englishIqMilestoneSchema.nullable(),
  startedAt: z.number().int().positive(),
  token: z.string().min(1),
  version: z.literal(ENGLISH_IQ_STORED_SESSION_VERSION),
});

export type IEnglishIqStoredSession = z.infer<typeof englishIqStoredSessionSchema>;
